<div class="dialog-header">
  <h6 id="dialog-header-row" matDialogTitle>{{ tittle }}</h6>
  <button
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<div style="margin-bottom: 5px"></div>
<mat-dialog-content>
  <form [formGroup]="formData" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-label class="label-input">Short ID</mat-label>
      </div>
      <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
        <mat-form-field>
          <input
            type="text"
            matInput
            formControlName="ntIDCtr"
            [(ngModel)]="user.ntId"
            name="ntId"
          />
          <mat-error *ngIf="this.formData.get('ntIDCtr').hasError('required')"
            >This field is required!</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-label class="label-input">Email</mat-label>
      </div>
      <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
        <mat-form-field>
          <input
            type="email"
            matInput
            formControlName="emailCtr"
            [(ngModel)]="user.email"
            name="email"
          />
          <mat-error *ngIf="this.formData.get('emailCtr').hasError('required')"
            >This field is required!</mat-error
          >
          <mat-error *ngIf="this.formData.get('emailCtr').hasError('email')"
            >Not valid email!</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-label class="label-input">Email Recipient Class</mat-label>
      </div>

      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" style="margin-top: 1em">
        <mat-radio-group name="opList" fxLayout="row">
          <mat-radio-button
            *ngFor="let class of emailRecipientClass; let $index = index"
            [value]="class"
            name="opList"
            (change)="emailRecipientClassChange(class)"
            [checked]="$index === 0"
            >{{ class }}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-label class="label-input">Role</mat-label>
      </div>
      <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
        <mat-form-field *ngIf="roles !== undefined">
          <mat-select
            [(ngModel)]="user.role"
            formControlName="roleCtr"
            placeholder="Select role"
            (selectionChange)="roleChange($event.value)"
          >
            <mat-option *ngFor="let item of roles" [value]="item">{{
              item.name
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="error.role">{{ error.role }}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-label class="label-input">Feature: {{ countSelected }}</mat-label>
      </div>
      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 alignTop">
        <button
          id="addFeaturesbtn"
          type="button"
          class="button-primary"
          (click)="showFeaturePopup()"
          [disabled]="!allowShowAddFeatureButton"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="submit icon"
              class="bosch-ic-add-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-label class="label-input">Site </mat-label>
      </div>
      <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
        <mat-form-field *ngIf="SINGLE_SITE === true">
          <mat-select
            formControlName="projectCtr"
            (selectionChange)="siteChange($event)"
            [(ngModel)]="selectedSiteIds[0]"
            placeholder="Select site"
            required
          >
            <mat-option>Site</mat-option>
            <mat-option
              *ngFor="let item of sites; let i = index"
              [value]="item.siteId"
              >{{ item.siteName }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="isFieldHasError('projectCtr', 'required')"
            >This field is required.</mat-error
          >
        </mat-form-field>

        <mat-form-field *ngIf="MULTIPLE_SITE === true">
          <mat-select
            multiple
            formControlName="projectCtr"
            (selectionChange)="siteChange($event)"
            [(ngModel)]="selectedSiteIds"
            (ngModelChange)="(selectedSiteIds)"
            placeholder="Select site"
            required
          >
            <mat-option>Site</mat-option>
            <mat-option
              *ngFor="let item of sites; let i = index"
              [value]="item.siteId"
              >{{ item.siteName }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="isFieldHasError('projectCtr', 'required')"
            >This field is required.</mat-error
          >
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <div class="pull-right" style="margin-top: 1em">
    <button
      type="button"
      id="resetIdbtn"
      class="button-primary"
      (click)="reset()"
      style="margin-right: 3px"
    >
      <span>
        <mat-icon
          aria-hidden="false"
          aria-label="submit icon"
          class="bosch-ic-refresh"
          style="width: max-content"
        ></mat-icon>
      </span>
      Clear Fields
    </button>
    &nbsp;
    <button
      type="button"
      id="addUserbtn"
      class="button-primary"
      [disabled]="!formData.valid"
      (click)="save()"
    >
      <span>
        <mat-icon
          aria-hidden="false"
          aria-label="submit icon"
          class="bosch-ic-checkmark-frame"
          style="width: max-content"
        ></mat-icon>
      </span>
      {{ add_eidt_label }}
    </button>
  </div>
</mat-dialog-footer>
